import { useState, useCallback } from 'react'
import { DefDossierItem } from '../model/types'
import { KedoContext } from '../model/types'

export const useMainMenuItems = (kedo: KedoContext) => {
    const [main, setMain] = useState<DefDossierItem[]>([])
    const [other, setOther] = useState<DefDossierItem[]>([])
    const [hidden, setHidden] = useState<DefDossierItem[]>([])

    const clearMenu = useCallback(() => {
        setMain([])
        setOther([])
        setHidden([])
    }, [])

    const fetchMenuItems = useCallback(() => {
        const env = kedo.env().getEnvironment()
        if (!env) {
            clearMenu()
            return
        }

        const ddItems: DefDossierItem[] =
            kedo.env().getCurrentEnvironmentDefDossiers() || []

        if (!ddItems || !Array.isArray(ddItems)) {
            clearMenu()
            return
        }

        const filteredItems = ddItems.filter((item) =>
            kedo.env().isAllowedDefDossier('show', item.id, kedo.user())
        )

        const roleFilteredItems = filteredItems.filter((item) => {
            const visibilityRoles = item.visibility_roles?.length
                ? item.visibility_roles
                : item.settings?.visibility_roles ?? []

            if (!visibilityRoles.length) return true

            const curRoles = kedo.env().getCurrentEnvironmentRoles()
            const currentRoleIds = new Set(
                curRoles.map((role) => String(role.id))
            )

            return !visibilityRoles.some((role) =>
                currentRoleIds.has(
                    String(typeof role === 'object' ? role.id : role)
                )
            )
        })

        setMain(
            roleFilteredItems
                .filter((i) => i.type === 'main')
                .sort((a, b) => a.rank - b.rank)
        )
        setHidden(
            roleFilteredItems
                .filter((i) => i.type === 'hidden')
                .sort((a, b) => a.rank - b.rank)
        )
        setOther(
            roleFilteredItems
                .filter((i) => i.type !== 'main' && i.type !== 'hidden')
                .sort((a, b) => a.rank - b.rank)
        )
    }, [kedo, clearMenu])

    return { main, other, hidden, fetchMenuItems }
}
